import { render, staticRenderFns } from "./ComparativeTableDefault.vue?vue&type=template&id=7ea86387&scoped=true"
import script from "./ComparativeTableDefault.vue?vue&type=script&lang=js"
export * from "./ComparativeTableDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea86387",
  null
  
)

export default component.exports